'use client';

import { SCREEN_SIZE } from '@fe-news/styles/style';
import { styled } from '@linaria/react';
import Link from 'next/link';

const LABEL_COLORS = ['#ddbe43', '#b1bed0', '#d18552', '#848d97', '#848d97'];

const AIGC_UTM_PARAMS = '?utm_campaign=aigc_hot&utm_content=aigc&utm_term=';

const ANOTHER_UTM_PARAMS = '?utm_campaign=aigc_hot&utm_content=news&utm_term=';

const AiGcTitleLink = styled(Link)`
  display: block;
  border-bottom: 1px solid #e2e8f1;
  min-height: 81px;

  &:nth-child(2) {
    @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
      margin-top: 8px;
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;

const Container = styled.div<{ color: string }>`
  display: flex;
  align-items: center;
  padding: 12px 0px;
  min-height: 77px;

  i {
    font-style: italic;
    font-size: 22px;
    line-height: 1.09;
    margin-right: 6px;
    color: ${({ color }) => color || ''};
  }

  @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
    padding: 16px 0px;
  }
`;

const AiGcTitleTitle = styled.p`
  flex: 1;
  font-size: 16px;
  line-height: 1.5;
  color: #383838;
  text-align: left;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: ${SCREEN_SIZE.DESKTOP}px) {
    font-size: 19px;
  }

  &:hover {
    color: #e03f19;
  }
`;

type AiGcTitleProps = {
  title: string;
  url: string;
  index: number;
  isAiGc?: boolean;
};

const AiGcTitle = ({ title, url, index, isAiGc = false }: AiGcTitleProps) => {
  const urlWithUtm = `${url}${isAiGc ? AIGC_UTM_PARAMS : ANOTHER_UTM_PARAMS}${title}`;

  return (
    <AiGcTitleLink href={urlWithUtm} prefetch={false}>
      <Container color={LABEL_COLORS[index]}>
        <i>{index + 1}.</i>
        <AiGcTitleTitle>{title}</AiGcTitleTitle>
      </Container>
    </AiGcTitleLink>
  );
};

export default AiGcTitle;
